import React from 'react'
import HTag from '@/lib/HTag'

const FileList = ({ heading, items }) => (
	<section className="section">
		<HTag className="h1" {...heading} />

		<div className="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-8 mt-8">
			{items?.map((item, key) => (
				<article key={key}>
					<HTag className="h2" {...item.heading} />
					<ul>
						{item.files?.map(({ file, name }, key) => !!file && (
							<li key={key}>
								<a className="link text-orange" href={file.asset.url}>
									{name}
								</a>
							</li>
						))}
					</ul>
				</article>
			))}
		</div>
	</section>
)

export default FileList
